import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  ElementRef,
} from "@angular/core";
import { PermissionsService } from "app/modules/admin/auth/permission/permissions.service";
import { ParameterEdit } from "./parameter.models";

@Directive({
    selector: "[permissionOnly]",
    standalone: false
})
export class PermissionOnlyDirective {
  private hasViewOnly = false;

  private hasViewUser = false;

  private hasViewCondition = false;

  private hasView = false;

  constructor(
    private templateRef: TemplateRef<ElementRef>,
    private viewContainer: ViewContainerRef,
    private permissionsService: PermissionsService
  ) { }

  @Input() set permissionOnly (rules: string[]) {
    if (this.permissionsService.checkIfHaveRules(rules) && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
      this.hasViewOnly = true;
    } else if (
      !this.permissionsService.checkIfHaveRules(rules) &&
      this.hasView
    ) {
      this.viewContainer.clear();
      this.hasView = false;
      this.hasViewOnly = false;
    }
  }

  @Input() set permissionOnlyUserCreatedOrSuperUser (parameter: ParameterEdit) {
    if (
      this.permissionsService.checkIfHaveRules(parameter.rules) ||
      parameter.id === this.permissionsService.user.id
    ) {
      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
      this.hasViewOnly = true;
      this.hasViewUser = true;
    } else {
      this.viewContainer.clear();
      this.hasView = false;
      this.hasViewUser = false;
    }
  }

  @Input() set permissionOnlyUserCreated (id: number) {
    if (id !== this.permissionsService.user.id) {
      this.viewContainer.clear();
      this.hasView = false;
      this.hasViewUser = false;
    } else {
      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
      this.hasViewOnly = true;
      this.hasViewUser = true;
    }
  }

  @Input() set permissionOnlyConditional (condition: boolean) {
    if (condition && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
      this.hasViewCondition = true;
    } else if (!condition && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
      this.hasViewCondition = false;
    }
  }

  @Input() set permissionOnlyType (type: string) {
    if (type === "OR") {
      this.hasView =
        this.hasViewOnly || this.hasViewUser || this.hasViewCondition;
      if (this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    } else {
      this.hasView =
        this.hasViewOnly && this.hasViewUser && this.hasViewCondition;
      if (this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    }
  }
}
